export const APP_INFO = {
    name: "PassTickets",
    email: "support@pass-tickets.com",
    phone: "+966 92 002 5515",
    social_media: {
        whatsapp: "+966 53 005 3321",
    },
}

export type AppInfo = {
    name: string
    address: string
    phone: string
    email: string
    website: string
    logo: string
    slogan: string
    social_media: SocialMedia
}

export type SocialMedia = {
    facebook: string
    twitter: string
    instagram: string
    linkedin: string
    youtube: string
    snapchat: string
    whatsapp: string
}
